defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/PurchaseFlow/FundingTimeExceededModal',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Utils',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton'
  ],
  function (m, Utils, CtaButton) {
    var FundingTimeExceededModal = {
      controller: function ({ controller }) {
        Object.assign(this, controller);
        this.dictionary = this.rootDictionary.get.bind({ prefix: 'Shared/PurchasePlayFundingTimeExceededOverlay/' });

        const gameTypePathName = Utils.mapGameToDictionary(this.gameType());
        const footer = [
          CtaButton({
            text: this.dictionary('GoToChooseGame'),
            href: `${this.navigationPaths.createPlayChooseGamePage}?klubId=${this.clubId()}`,
            options: ['primary']
          })
        ];

        const modalContent = this.modal.defaultContentTemplate({
          heading: m.trust(this.dictionary('Title')),
          body: m.trust(this.dictionary(`${gameTypePathName}Description`)),
          footer
        });

        this.checkFundingTime = () => {
          let noOpenDraw = this.game()?.infoFeed()?.noOpenDraw();
          if (!noOpenDraw && this.game()?.infoFeed()?.getOpenDraw()) {
            const now = new Date();
            const closingTime = this.game().infoFeed().getOpenDraw().closingTime;
            const fundingEndTime = Utils.parseISO8601(closingTime).dateObject;
            fundingEndTime.setHours(fundingEndTime.getHours() - 2);
            noOpenDraw = now >= fundingEndTime;
          }
          if (noOpenDraw && !this.modal.isRendered()) {
            this.modal.setContent(modalContent);
            this.modal.show();
          }

          return m('div', null);
        };
      },
      view: function (controller) {
        return controller.checkFundingTime();
      }
    };

    // Public functions:
    return FundingTimeExceededModal;
  });
